import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class LoadingService {
	private _isLoading = new BehaviorSubject<boolean>(false);

	get isLoading() {
		return this._isLoading.asObservable();
	}

	showLoading() {
		this._isLoading.next(true);
	}

	hideLoading() {
		setTimeout(() => {
			this._isLoading.next(false);
		}, 300);
	}
}
